import { Severity, CaptureContext } from "@sentry/types";
import logger from "./configure";

export type MaybeError = Error | undefined | null;
export type Callback<TResponse = unknown> = (
  err: MaybeError,
  response: TResponse
) => void;
export type LogArgument = string | Error | object | Callback | Date | undefined;
export type { CaptureContext };
export { Severity };

export type LogFunction = (arg: LogArgument, opts?: CaptureContext) => void;

export type Loggy = {
  info: LogFunction;
  error: LogFunction;
  log: LogFunction;
  debug: LogFunction;
  warning: LogFunction;
};

const loggy: Loggy = {
  info: (arg, opts = {}) =>
    logger.captureException(arg, {
      level: Severity.Info,
      ...opts,
    }),
  error: (arg, opts = {}) =>
    logger.captureException(arg, {
      level: Severity.Error,
      ...opts,
    }),
  log: (arg, opts = {}) =>
    logger.captureException(arg, {
      level: Severity.Log,
      ...opts,
    }),
  debug: (arg, opts = {}) =>
    logger.captureException(arg, {
      level: Severity.Debug,
      ...opts,
    }),
  warning: (arg, opts = {}) =>
    logger.captureException(arg, {
      level: Severity.Warning,
      ...opts,
    }),
};

export default loggy;
